<h1 mat-dialog-title>¡ Algo salio mal !</h1>
<div mat-dialog-content>
    <p>{{data.message}}</p>
</div>